import { backendPy } from "System/system";
import store from "System/reduxStore";

// -------------------------------------------------------
// -------------------------------------------------------
export const addRegexFilter = (filter) => {
  return {
    type: "ADD_REGEX_FILTER",
    filter,
  };
};

// -------------------------------------------------------
// -------------------------------------------------------
export const removeRegexFilter = (column) => {
  return {
    type: "REMOVE_REGEX_FILTER",
    column,
  };
};

// -------------------------------------------------------
// -------------------------------------------------------
export const updateRegexPattern = (column, pattern) => {
  return {
    type: "UPDATE_REGEX_PATTERN",
    column,
    pattern,
  };
};

// -------------------------------------------------------
// -------------------------------------------------------
export const applyRegexFilters = (cb) => async (dispatch) => {
  const { id, datapath, regexFilters } = store.getState().project;
  const projectid = id;

  const input = [];
  for (const filter of regexFilters) {
    const col = filter.column;
    const pattern = filter.pattern;
    input.push({ col, pattern });
  }

  await backendPy("filter", "apply_regex", {
    projectid,
    datapath,
    filters: JSON.stringify(input),
  });

  dispatch({
    type: "CHANGE_REGEX_FILTER_STATUS",
    regexFiltersHaveChanged: false,
  });
  if (cb) cb();
};
